// extracted by mini-css-extract-plugin
export var icon = "Icon-module__icon___6ICyA";
export var large = "Icon-module__large___BlOBd";
export var medium = "Icon-module__medium___ybk1w";
export var small = "Icon-module__small___Wn-vn";
export var xLarge = "Icon-module__xLarge___Hh0AA";
export var xSmall = "Icon-module__xSmall___yjDD8";
export var xxLarge = "Icon-module__xxLarge___n0YBZ";
export var xxSmall = "Icon-module__xxSmall___vViZA";
export var xxxLarge = "Icon-module__xxxLarge___sXrvq";